import React, {useEffect, useState} from 'react';
import cc from 'classcat';
import {Capacitor} from '@capacitor/core';
import {StatusBar, Style} from '@capacitor/status-bar';
import {useTranslation} from 'react-i18next';

import BottomNavigation from '@/layouts/BottomNavigation';
import Header from '@/layouts/Header';
import Layout from '@/layouts';

import styles from './styles.module.scss';
import CollectionTop from './components/Top';
import CollectionLists from './components/Lists';

export interface CollectionItemInfo {
  title: string;
  ticker: string;
  subTxt: string;
  isLike: boolean;
  preOpen?: boolean;
}

export default function Collections() {
  const [tab, setTab] = useState<string>('all');
  const {t} = useTranslation(['views'], {keyPrefix: 'collection.index'});

  useEffect(() => {
    if (Capacitor.getPlatform() !== 'web') {
      StatusBar.setStyle({
        style: Style.Light,
      });
    }
  }, [window.location.pathname]);

  return (
    <Layout.Main>
      <div>
        <Header
          title={t('header')}
          isTransparent
          isCommunity
          isWhite
          isNoRing
        />
        <div className={cc([styles.wrapper, 'collection'])}>
          <CollectionTop />
          <CollectionLists tab={tab} setTab={setTab} />
        </div>
        <BottomNavigation />
      </div>
    </Layout.Main>
  );
}
